
/**
 * This is a simple Vue.js mixin that checks for
 * a validate method on child components. If the method
 * exists it runs the method and ensures that the form
 * does not submit if the method returns a falsy value.
 */
export default {
  data () {
    return {
      phoneValue: this.phone,
      phoneCountry: '',
      phoneCountryValue: '',
      phoneValid: false,
      phoneActive: false,
      phoneSendSMS: false
    }
  },
  methods: {
    phoneValidation (output = false, allowEmpty = true) {
      const classesRemove = ['has-errors', 'has-errors--alt']
      const phoneInput = this.$refs['phone']

      if (this.phoneSendSMS && (!this.phoneValid || this.phoneCountry !== 'US')) {
        if (output) {
          phoneInput.classList.remove(...classesRemove)
          phoneInput.classList.add('has-errors--alt')
        }

        return false
      }

      if (!this.phoneValue) {
        if (allowEmpty) {
          if (output) {
            phoneInput.classList.remove(...classesRemove)
          }
          return true
        }
        if (output) {
          phoneInput.classList.remove(...classesRemove)
          phoneInput.classList.add('has-errors')
        }
        return false
      }

      if (this.phoneValue && !this.phoneValid) {
        if (output) {
          phoneInput.classList.remove(...classesRemove)
          phoneInput.classList.add('has-errors')
        }

        return false
      }

      if (output) {
        phoneInput.classList.remove(...classesRemove)
      }

      return true
    },
    phoneOnChange (value, phoneObj) {
      this.phoneCountryValue = `+${phoneObj.country?.dialCode}`
      if (value) {
        this.phoneActive = true
      }
      if (typeof this.onPhoneChangeCallback === 'function') {
        this.onPhoneChangeCallback(value)
      }
      this.phoneValidation(true)
    },
    phoneCountryChange (event) {
      const countryIsoCode = event.iso2
      this.phoneCountry = countryIsoCode
    },
    phoneFocus () {
      this.phoneActive = true
    },
    phoneBlur () {
      if (!this.phoneValue) {
        this.phoneActive = false

        this.phoneValidation(true)
      }
    },
    validatePhone (event) {
      this.phoneValid = event.valid
      this.phoneValidation(true)
    }
  }
}
